import { useEffect } from "react"
import { logEvent } from "../../../utilities"
import { useSelector } from 'react-redux'

const SESSION_LOGGED_KEY = 'cdl-logged-if-mobile-session'

const MobileLogger = () => {
    const authenticated = useSelector(_ => _.data.authenticated)

    useEffect(() => {
        if (authenticated) {
            const logged = sessionStorage.getItem(SESSION_LOGGED_KEY)    
    
            if (!logged && !!window) {            
                const width = window.innerWidth
                const SessionDeviceType = 
                    width <= 480 ? 'phone' :
                    width <= 768 ? 'tablet' :
                    'desktop'
                
                logEvent({ SessionDeviceType })
                sessionStorage.setItem(SESSION_LOGGED_KEY, true)
            }
        }
    }, [authenticated])
}

export default MobileLogger
